<template>
  <div>
    <div class="container">
      <h2 class="resp-in-progress_title">Отклики</h2>
    </div>
    <filter-by-price
      v-if="!isLoadingResp && !isDispatcherRole"
      :filter="priceFilter"
      @set="updateFilterByPrice"
    />
    <div class="bids-list container">
      <el-table
        v-if="isLoadingResp || !generatedList.length"
        v-loading="isLoadingResp"
        :data="generatedList"
        class="table-class"
      />
      <section v-else class="middle-section">
        <el-row :gutter="20" style="text-align: center; margin: 15px 0 10px">
          <el-col :span="1">
            <el-checkbox
              v-model="checkAll"
              :indeterminate="isIndeterminate"
              @change="handleCheckAllChange"
            />
          </el-col>
          <el-col :span="2">Дата</el-col>
          <el-col :span="4">ФИО</el-col>
          <el-col :span="2">Авто/прицеп</el-col>
          <el-col :span="4">Перевозчик</el-col>
          <el-col :span="3">Цена</el-col>
          <el-col :span="4">Флаги</el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-checkbox-group
              v-model="checked_request"
              @change="handleCheckedChange"
            >
              <transition-group name="slide-fade" tag="div">
                <div
                  v-for="response in generatedList"
                  :key="response.id"
                  :ref="'response' + response.id"
                  :class="[
                    'check-list',
                    { 'active-response': activeResponseStyle === response.id },
                    {
                      'overdue-response':
                        getHighlightResponseId === response.id,
                    },
                  ]"
                >
                  <el-col class="auto-list_col" :span="1">
                    <div class="check-list-time auto-list_col_centered">
                      <el-checkbox :label="response" :value="response" />
                    </div>
                  </el-col>
                  <div @click="callModal(response)">
                    <el-col class="auto-list_col" :span="2">
                      <column-date
                        :response="response"
                        @open="setOpen(response, 'statusDialog')"
                      />
                    </el-col>

                    <el-col class="auto-list_col" :span="4">
                      <column-short-fio
                        :response-driver-fio="response.driver.fio"
                        :status="response.nds_status"
                      />
                    </el-col>

                    <el-col class="auto-list_col" :span="2">
                      <column-state-numbers
                        :response-auto="response.auto"
                        :show-deleted-list="showDeletedList"
                      />
                    </el-col>

                    <el-col class="auto-list_col" :span="4">
                      <column-carrier
                        :id="response.id"
                        :contract-status="getStatusContract(response)"
                        :response-auto="response.auto"
                        :response-user-role="response['user-role']"
                        :response-auto-inn="responseAutoInn"
                        :count-comments="countComments"
                        @addComment="callAddCommentModal"
                        @showCommentsModal="showCommentsModal"
                      />
                    </el-col>

                    <el-col class="auto-list_col" :span="3">
                      <column-price
                        :response="response"
                        :type="bid.type_code"
                        :is-tudatka="bid.is_tudatka"
                        @open="setOpen(response, 'editPriceDialog')"
                      />
                    </el-col>

                    <el-col
                      v-loading="!response"
                      class="auto-list_col"
                      :span="4"
                    >
                      <column-buttons-for-modals
                        :response="response"
                        :on-t-t-n-click="onTTNClick"
                        :on-payment-click="onPaymentClick"
                        :on-act-click="onActClick"
                      />
                    </el-col>

                    <el-col class="auto-list_col" :span="2">
                      <column-verify :response="response" />
                    </el-col>
                  </div>

                  <el-col
                    v-if="canAction('deleteResponse')"
                    class="auto-list_col"
                    :span="2"
                  >
                    <column-action
                      :response="response"
                      @open="setOpen(response, 'isShowDialogResponseMove')"
                      @comment="fetchResponses"
                      @delete="fetchResponses"
                    />
                  </el-col>
                </div>
              </transition-group>
            </el-checkbox-group>
          </el-col>
        </el-row>
      </section>
      <approve-response
        v-if="generatedList.length"
        :send-approve="sendApprove"
        :checked-request="checked_request"
        @openSmsDialog="smsDialog = true"
      />
    </div>
    <template v-if="generatedList.length">
      <el-dialog
        class="passport_dialog_window"
        width="auto"
        :visible.sync="passportDialog"
        append-to-body
      >
        <passport-fill :current-person="currentPerson" :type="bid.type_code" />
      </el-dialog>
      <el-dialog
        class="passport_dialog_window"
        width="auto"
        :visible.sync="callAddComment"
        append-to-body
      >
        <comment-fill
          :id="commentModalId"
          @closeModalComment="updateComments"
        />
      </el-dialog>
      <el-dialog
        class="passport_dialog_window"
        width="auto"
        :visible.sync="showComments"
        append-to-body
      >
        <comments-fill
          :carrier-name="carrierName"
          :comments-list="commentsModalsList"
          @closeModalComments="showComments = false"
        />
      </el-dialog>
      <bids-payments-modal
        :payment-dialog="paymentDialog"
        :loading="paymentLoading"
        :paying-loader="payingLoader"
        :response="activeResponse || {}"
        :active-act="activeAct"
        :bid="bid"
        @close="paymentDialog = false"
        @update="fetchResponses"
      />
      <modal-ttn
        :response="TTNMode"
        :shortage="shortage"
        :load-date="day.load_date"
        :type="bid.type_code"
        @close="TTNMode = null"
        @update="fetchResponses"
      />
      <bids-act-modal
        :act-dialog="actDialog"
        :response="activeActResponse || {}"
        :active-act="activeAct || {}"
        :doc-types="docTypes"
        :loader="loader"
        @close="
          actDialog = false
          activeAct = null
        "
        @update="fetchResponses"
        @status="fetchResponses"
        @set="updatePerformer"
      />
      <resp-status-modal
        :visible="statusDialog"
        :response="getActiveResponse()"
        :day="day.load_date"
        @close="onClose('statusDialog')"
        @updateStatus="updateResponseStatus"
      />
      <send-sms-modal
        :visible="smsDialog"
        :checked-request="checked_request"
        :response="getActiveResponse()"
        :day="day.load_date"
        @close="onClose('smsDialog')"
        @update="fetchResponses"
      />
      <dialog-response-move
        :visible="isShowDialogResponseMove"
        :load-days="bid['load_days']"
        :response="activeResponse"
        @close="isShowDialogResponseMove = false"
        @update="updateResponseMoveHandler"
      />
      <save-nomenclature :bid="bid.id" />
      <edit-prices-modal
        :id="bid.id"
        :visible="editPriceDialog"
        :type="bid.type_code"
        :response="activeResponse"
        @close="onClose('editPriceDialog')"
        @update="fetchResponses()"
      />
    </template>
  </div>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { SET_SELECTED_RESPONSE } from '@/store/actions/loadDay'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import ApproveResponse from '@/views/LoadDay/Components/Responses/ApproveResponse'
import BidsActModal from '@/views/LoadDay/Modals/Act/BidsActModal'
import BidsPaymentsModal from '@/views/LoadDay/Modals/Payments/BidsPaymentsModal'
import ColumnAction from '@/views/LoadDay/Components/Responses/Columns/Action'
import ColumnButtonsForModals from '@/views/LoadDay/Components/Responses/Columns/ButtonsForModals'
import ColumnCarrier from '@/views/LoadDay/Components/Responses/Columns/Carrier'
import ColumnDate from '@/views/LoadDay/Components/Responses/Columns/Date'
import ColumnPrice from '@/views/LoadDay/Components/Responses/Columns/Price'
import ColumnShortFio from '@/views/LoadDay/Components/Responses/Columns/ShortFIO'
import ColumnStateNumbers from '@/views/LoadDay/Components/Responses/Columns/StateNumbers'
import ColumnVerify from '@/views/LoadDay/Components/Responses/Columns/Verify'
import CommentFill from '@/components/Forms/CommentFill'
import CommentsFill from '@/components/Forms/CommentsFill'
import DialogResponseMove from '@/views/LoadDay/Modals/ResponseMove/ResponseMove'
import EditPricesModal from '@/views/LoadDay/Modals/EditPricesModal'
import FilterByPrice from '@/views/LoadDay/Components/Responses/Filters/FilterByPrice'
import ModalTtn from '@/components/Modals/ModalTTN'
import PassportFill from '@/components/Forms/PassportFill'
import RespStatusModal from '@/views/LoadDay/Modals/RespStatusModal'
import SaveNomenclature from '@/views/LoadDay/Components/SaveNomenclature'
import SendSmsModal from '@/views/Home/Shipping/Modals/SendSmsModal'

const Approvements = RepositoryFactory.get('approvements')
const DocApi = RepositoryFactory.get('document')
const TtnApi = RepositoryFactory.get('ttn')

export default {
  name: 'Responses',
  components: {
    SendSmsModal,
    CommentsFill,
    CommentFill,
    EditPricesModal,
    SaveNomenclature,
    BidsPaymentsModal,
    ModalTtn,
    PassportFill,
    BidsActModal,
    RespStatusModal,
    ApproveResponse,
    FilterByPrice,
    DialogResponseMove,
    ColumnDate,
    ColumnShortFio,
    ColumnStateNumbers,
    ColumnCarrier,
    ColumnPrice,
    ColumnVerify,
    ColumnButtonsForModals,
    ColumnAction,
  },
  props: {
    showDeletedList: {
      type: Boolean,
      default: false,
    },
    bid: {
      type: Object,
      default: () => {},
    },
    day: {
      type: Object,
      default: () => {},
    },
    status: {
      type: Number,
      default: null,
    },
    list: {
      type: Array,
      default: () => [],
    },
    priceFilter: {
      type: Object,
      default: () => {},
    },
    fetch: {
      type: Function,
      default: () => {},
    },
    updateResponse: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      carrierName: '',
      responseAutoInn: '',
      countComments: 0,
      commentModalId: 0,
      commentsModalsList: [],
      checked_request: [],
      passportDialog: false,
      callAddComment: false,
      showComments: false,
      currentPerson: [],
      checkAll: false,
      isIndeterminate: false,
      TTNMode: null,
      statusDialog: false,
      editPriceDialog: false,
      paymentDialog: false,
      isShowDialogResponseMove: false,
      activeResponse: {},
      activeActResponse: null,
      activeAct: null,
      actDialog: false,
      smsDialog: false,
      loader: false,
      ttnLoader: false,
      responseTtnData: [],
      activeResponseStyle: null,
      generatedList: [],
    }
  },
  computed: {
    ...mapGetters({
      user: 'userProfile/userInfo',
      getLoading: 'loadDay/getLoading',
      paymentLoading: 'payments/getLoading',
      payingLoader: 'payments/getLoader',
      docTypes: 'documentTypes/getDocumentTypes',
      getHighlightResponseId: 'loadDay/getHighlightResponseId',
    }),
    isLoadingResp() {
      return this.getLoading('Resp')
    },

    shortage() {
      const res = {}

      if (this.bid) {
        const { allow_shortage_is_percents, allow_shortage } = this.bid

        res.perc = allow_shortage_is_percents
        res.val = allow_shortage || 0
      }

      return res
    },
  },
  watch: {
    list: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal?.length) {
          this.generatedList = newVal.map(item => {
            const ttnData = this.responseTtnData.filter(
              ttn => ttn.response_id === item.id,
            )

            return {
              ...item,
              ttnData,
              weightStatus: this.getWeightStateClass(item),
              ttnStatus: this.getTtnStateClass(ttnData),
            }
          })
          this.getResponsesTtn(newVal)
        } else {
          this.generatedList = []
        }
      },
    },
    checked_request() {
      this.setSelectedResponse(this.checked_request.map(item => item.id))
    },
    generatedList() {
      const overdueElem = this.$refs['response' + this.getHighlightResponseId]

      if (overdueElem) {
        overdueElem[0].scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    },
  },
  mounted() {
    const { response_id } = this.$route.query

    if (response_id) {
      this.activeResponseStyle = Number(response_id)
    }
    const overdueElem = this.$refs['response' + this.getHighlightResponseId]

    if (overdueElem) {
      this.$nextTick(() =>
        overdueElem[0].scrollIntoView({ behavior: 'smooth', block: 'center' }),
      )
    }
  },
  beforeDestroy() {
    this.setHighlightResponseId(0)
  },
  methods: {
    ...mapActions({
      fetchResponsesInDay: 'loadDay/fetchResponsesInDay',
      setSelectedResponse: `loadDay/${SET_SELECTED_RESPONSE}`,
    }),
    ...mapMutations({
      updateBid: 'loadDay/updateBid',
      setHighlightResponseId: 'loadDay/setHighlightResponseId',
    }),
    getStatusContract(response) {
      if (response && response.contragent_contract) {
        if (
          Boolean(response.contragent_contract.contract.is_current) &&
          Boolean(response.contragent_contract.contract.is_signed)
        ) {
          return 2
        }
        if (response.contragent_contract.contract.is_current) {
          return 1
        }

        return 0
      }

      return 0
    },

    fetchResponses(flag = null, id = null) {
      this.fetch().then(() => {
        id && (this.activeResponse = this.list.filter(r => r.id === id)[0])
      })

      if (flag) {
        this.fetchGetAct(flag)
      }
      this.setHighlightResponseId(0)
    },
    updateResponseStatus(data) {
      this.updateResponse(data)
    },
    showCommentsModal(list, carrierName) {
      this.commentsModalsList = list
      this.showComments = true
      this.carrierName = carrierName
      this.setHighlightResponseId(0)
    },
    updateComments() {
      this.callAddComment = false
      this.countComments += 1
    },
    setOpen(resp, key) {
      this.activeResponseStyle = resp.id

      if (key === 'statusDialog' && !this.canAction('editResponseStatus')) {
        return false
      }
      this.activeResponse = resp
      this[key] = true
      this.setHighlightResponseId(0)
    },
    onClose(key) {
      this[key] = false
      this.activeResponse = {}
    },
    getWeightStateClass(response) {
      const def = response.unacceptable_deficiency

      if (def === 0) {
        return 'success'
      }
      if (def > 0) {
        return 'danger'
      }

      return ''
    },
    getTtnStateClass(ttnData) {
      if (!ttnData.length) {
        return 'danger'
      }
      if (
        ttnData.some(ttn => !ttn.brutto_fact || !ttn.img_url || !ttn.brutto_ttn)
      ) {
        return 'warning'
      }

      return 'success'
    },
    callModal(response) {
      if (!response.auto) {
        response = { ...response, auto: {} }
      }
      this.currentPerson = response
      this.passportDialog = true
      this.activeResponseStyle = response.id
      this.setHighlightResponseId(0)
    },
    callAddCommentModal(id, inn) {
      this.callAddComment = true
      this.commentModalId = id
      this.responseAutoInn = inn
      this.setHighlightResponseId(0)
    },
    sendApprove(newStatus) {
      this.checked_request.forEach(res => {
        Approvements.postApprovements({
          link_by_rel: 'responses',
          link_by_id: res.id,
          status: newStatus,
          create_master_approve: 1,
          user_org_inn: Number(this.user.current.organization.inn),
        }).then(() => {
          this.fetchResponses()
          this.checked_request = []
          this.checkAll = false
        })
      })
    },
    handleCheckAllChange(val) {
      this.checked_request = val ? this.generatedList : []
      this.isIndeterminate = false
      this.setHighlightResponseId(0)
    },
    handleCheckedChange(value) {
      const checkedCount = value.length

      this.checkAll = checkedCount === this.generatedList.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.generatedList.length
      this.setHighlightResponseId(0)
    },
    onPaymentClick(response) {
      this.activeResponseStyle = response.id
      this.activeResponse = response
      this.setHighlightResponseId(0)
      this.fetchGetAct(response)
      this.paymentDialog = true
    },
    onTTNClick(response) {
      this.TTNMode = response
      this.activeResponseStyle = response.id
      this.setHighlightResponseId(0)
    },
    onActClick(response) {
      this.activeResponseStyle = response.id
      this.actDialog = true
      this.activeActResponse = response
      this.activeActResponse.bid = {
        org_performer_id: this.bid.org_performer_id,
      }
      this.loader = true
      this.setHighlightResponseId(0)
      this.fetchGetAct(response)
    },
    updatePerformer({ data }) {
      this.activeActResponse = {
        ...this.activeActResponse,
        bid: { org_performer_id: data.org_performer_id },
      }
      this.updateBid({ data })
    },
    async fetchGetAct(response) {
      const documentType = this.docTypes.find(t => t.code === 'works_act')

      try {
        const { data } = await DocApi.getDocument(
          'responses',
          response.id,
          documentType.code,
        )

        this.activeAct = Array.isArray(data)
          ? data.find(c => c.files.length) || data[0]
          : null
      } catch (error) {
        this.errHandler(error)
      } finally {
        this.loader = false
      }
    },
    getResponsesTtn(responses) {
      const TtnListPromise = responses.map(response =>
        TtnApi.getList(response.id),
      )

      this.ttnLoader = true
      Promise.all(TtnListPromise)
        .then(resp => {
          const { data: allTtns } = resp.reduce(
            (a, b) => ({ data: [...a.data, ...b.data] }),
            { data: [] },
          )

          this.responseTtnData = allTtns
        })
        .catch(e => this.errHandler(e))
        .finally(() => (this.ttnLoader = false))
    },
    updateFilterByPrice(priceFilter) {
      this.$emit('filter', priceFilter)
    },
    getActiveResponse() {
      return this.generatedList.filter(r => r.id === this.activeResponse?.id)[0]
    },
    updateResponseMoveHandler() {
      this.$emit('updateDate')
      this.fetchResponses()
      this.activeResponseStyle = null
    },
  },
}
</script>

<style lang="sass">
.bids-list .middle-section .check-list
  margin: 0 0 20px

.bids-list
  .table-class
    width: 100%
    height: 40vh
    margin-top: 20px
  .middle-section
    .active-response
      border: 1px solid #3498DB
    .overdue-response
      border: 2px solid red
    .check-list
      cursor: pointer
      margin: 0 0 20px
      background: #fff
      align-items: center
      height: 100px
      box-shadow: 0 2px 12px 0 rgba(0,0,0,.1)
      .auto-list_col
        height: 100px

        .auto-list_col_centered
          height: 100%
          display: grid
          align-items: center
          text-align: center

      .check-list-time
        text-align: center

      .check-list-phone
        font-size: 16px
        line-height: 21px

      .check-list-autos
        font-size: 14px
        line-height: 21px

      .check-list-action
        img
          margin: 10px

      .check-list-person
        p
          margin: 5px
          font-size: 16px
          line-height: 22px

      .grey
        color: #98A9BC

.mr25
  margin-right: 25px

.flex__center
  display: flex
  justify-content: center
  align-items: center
</style>
